import { FC } from "react";
import styled from "styled-components";
import publicPath from "../../helpers/publicPath";
import A from "../A";

type LogoProps = {
  width: string;
  height?: string | null;
  alt?: string;
  img: string;
  link?: string | null;
};

const LogoWrapper = styled.div<{ width: string; height: string | null }>`
  flex: none;
  width: ${(props) => props.width};
  max-width: ${(props) => props.width};
  min-width: ${(props) => props.width};
  height: ${(props) => props.height};
  max-height: ${(props) => props.height};
  min-height: ${(props) => props.height};
`;

const Img = styled.img<{ width: string; height: string | null }>`
  width: ${(props) => props.width};
  max-width: ${(props) => props.width};
  min-width: ${(props) => props.width};
  height: ${(props) => props.height};
  max-height: ${(props) => props.height};
  min-height: ${(props) => props.height};
`;

export const Logo: FC<LogoProps> = ({
  width,
  alt,
  img,
  link = null,
  height = null,
}) => {
  return (
    <LogoWrapper width={width} height={height}>
      {link && (
        <A to={link}>
          <Img src={publicPath(img)} alt={alt} width={width} height={height} />
        </A>
      )}
      {!link && (
        <Img src={publicPath(img)} alt={alt} width={width} height={height} />
      )}
    </LogoWrapper>
  );
};

export default Logo;
